<template>
  <component :is="currentComponent" :key="etapeKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')" />
</template>

<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';
import Etape4Inner from './Etape4Inner.vue';
import { taggage, taggageView, resetTag } from '@/utils/taggage.js';

defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const currentComponent = ref(Etape4Inner);

const etapeKey = ref(0);

//defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4']);
defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);




onMounted(() => {
  //console.log('Etape4 mounted');
  resetTag(4);
  taggage('configurateur_open', 'etape_4', 'display', { tealium_event: 'select_content' });
  //taggageView('XXXX', 'Orange', 'XXXX', 'portail', 'RES', 'global', 'XXXX', 'configurateur_etape_4', 'XXXX', 'Pack Open', 'internet', 'XXXX');
  taggageView('mobile web', 'Orange', '', 'portail', 'RES', 'global', 'configurateur_etape_4', 'Pack Open', 'internet', window.devicePixelRatio);
  // nextTick(() => {
  //   setTimeout(() => {
  //     window.scrollTo({ top: 0 });
  //   }, 0);
  // });
})


</script>
